/**
 * ThingsBoard REST API
 * For instructions how to authorize requests please visit
 * <a href=\'https://thingsboard.io/docs/reference/rest-api/\'>REST API documentation page</a>.
 *
 * The version of the OpenAPI document: 2.0
 * Contact: info@thingsboard.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';

import { DeferredResultResponseEntity } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

import { environment } from './../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DeviceApiControllerService {

    // protected basePath = 'https://iot.stinorland.com:443';
    protected basePath = environment.apiThingsboardUrl;
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;
    private clientKeyssharedKeys: any;

    // tslint:disable-next-line:max-line-length
    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === 'object' && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === 'object') {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error('key may not be null if value is Date');
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error('key may not be null if value is not object or array');
        }
        return httpParams;
    }

    /**
     * claimDevice
     * @param deviceToken deviceToken
     * @param json json
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    // tslint:disable-next-line:max-line-length
    public claimDeviceUsingPOST(deviceToken: string, json?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<DeferredResultResponseEntity>;
    // tslint:disable-next-line:max-line-length
    public claimDeviceUsingPOST(deviceToken: string, json?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpResponse<DeferredResultResponseEntity>>;
    // tslint:disable-next-line:max-line-length
    public claimDeviceUsingPOST(deviceToken: string, json?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpEvent<DeferredResultResponseEntity>>;
    // tslint:disable-next-line:max-line-length
    public claimDeviceUsingPOST(deviceToken: string, json?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*'}): Observable<any> {
        if (deviceToken === null || deviceToken === undefined) {
            throw new Error('Required parameter deviceToken was null or undefined when calling claimDeviceUsingPOST.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (X-Authorization) required
        credential = this.configuration.lookupCredential('X-Authorization');
        if (credential) {
            headers = headers.set('X-Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                '*/*'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<DeferredResultResponseEntity>(`${this.configuration.basePath}/api/v1/${encodeURIComponent(String(deviceToken))}/claim`,
            json,
            {
                responseType: responseType as any,
                withCredentials: this.configuration.withCredentials,
                headers,
                observe,
                reportProgress
            }
        );
    }

    /**
     * getDeviceAttributes
     * @param deviceToken deviceToken
     * @param clientKeys clientKeys
     * @param sharedKeys sharedKeys
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    // tslint:disable-next-line:max-line-length
    public getDeviceAttributesUsingGET(deviceToken: string, clientKeys?: string, sharedKeys?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<DeferredResultResponseEntity>;
    // tslint:disable-next-line:max-line-length
    public getDeviceAttributesUsingGET(deviceToken: string, clientKeys?: string, sharedKeys?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<DeferredResultResponseEntity>>;
    // tslint:disable-next-line:max-line-length
    public getDeviceAttributesUsingGET(deviceToken: string, clientKeys?: string, sharedKeys?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<DeferredResultResponseEntity>>;
    // tslint:disable-next-line:max-line-length
    public getDeviceAttributesUsingGET(deviceToken: string, clientKeys?: string, sharedKeys?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (deviceToken === null || deviceToken === undefined) {
            throw new Error('Required parameter deviceToken was null or undefined when calling getDeviceAttributesUsingGET.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (clientKeys !== undefined && clientKeys !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            clientKeys as any, 'clientKeys');
        }
        if (sharedKeys !== undefined && sharedKeys !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            sharedKeys as any, 'sharedKeys');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (X-Authorization) required
        credential = this.configuration.lookupCredential('X-Authorization');
        if (credential) {
            headers = headers.set('X-Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<DeferredResultResponseEntity>(`${this.configuration.basePath}/api/v1/${encodeURIComponent(String(deviceToken))}/attributes${encodeURIComponent(String(this.clientKeyssharedKeys))}`,
            {
                params: queryParameters,
                responseType: responseType as any,
                withCredentials: this.configuration.withCredentials,
                headers,
                observe,
                reportProgress
            }
        );
    }

    /**
     * postDeviceAttributes
     * @param deviceToken deviceToken
     * @param json json
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    // tslint:disable-next-line:max-line-length
    public postDeviceAttributesUsingPOST(deviceToken: string, json: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<DeferredResultResponseEntity>;
    // tslint:disable-next-line:max-line-length
    public postDeviceAttributesUsingPOST(deviceToken: string, json: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpResponse<DeferredResultResponseEntity>>;
    // tslint:disable-next-line:max-line-length
    public postDeviceAttributesUsingPOST(deviceToken: string, json: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpEvent<DeferredResultResponseEntity>>;
    // tslint:disable-next-line:max-line-length
    public postDeviceAttributesUsingPOST(deviceToken: string, json: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*'}): Observable<any> {
        if (deviceToken === null || deviceToken === undefined) {
            throw new Error('Required parameter deviceToken was null or undefined when calling postDeviceAttributesUsingPOST.');
        }
        if (json === null || json === undefined) {
            throw new Error('Required parameter json was null or undefined when calling postDeviceAttributesUsingPOST.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (X-Authorization) required
        credential = this.configuration.lookupCredential('X-Authorization');
        if (credential) {
            headers = headers.set('X-Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                '*/*'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<DeferredResultResponseEntity>(`${this.configuration.basePath}/api/v1/${encodeURIComponent(String(deviceToken))}/attributes`,
            json,
            {
                responseType: responseType as any,
                withCredentials: this.configuration.withCredentials,
                headers,
                observe,
                reportProgress
            }
        );
    }

    /**
     * postRpcRequest
     * @param deviceToken deviceToken
     * @param json json
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    // tslint:disable-next-line:max-line-length
    public postRpcRequestUsingPOST(deviceToken: string, json: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<DeferredResultResponseEntity>;
    // tslint:disable-next-line:max-line-length
    public postRpcRequestUsingPOST(deviceToken: string, json: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpResponse<DeferredResultResponseEntity>>;
    // tslint:disable-next-line:max-line-length
    public postRpcRequestUsingPOST(deviceToken: string, json: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpEvent<DeferredResultResponseEntity>>;
    // tslint:disable-next-line:max-line-length
    public postRpcRequestUsingPOST(deviceToken: string, json: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*'}): Observable<any> {
        if (deviceToken === null || deviceToken === undefined) {
            throw new Error('Required parameter deviceToken was null or undefined when calling postRpcRequestUsingPOST.');
        }
        if (json === null || json === undefined) {
            throw new Error('Required parameter json was null or undefined when calling postRpcRequestUsingPOST.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (X-Authorization) required
        credential = this.configuration.lookupCredential('X-Authorization');
        if (credential) {
            headers = headers.set('X-Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                '*/*'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<DeferredResultResponseEntity>(`${this.configuration.basePath}/api/v1/${encodeURIComponent(String(deviceToken))}/rpc`,
            json,
            {
                responseType: responseType as any,
                withCredentials: this.configuration.withCredentials,
                headers,
                observe,
                reportProgress
            }
        );
    }

    /**
     * postTelemetry
     * @param deviceToken deviceToken
     * @param json json
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    // tslint:disable-next-line:max-line-length
    public postTelemetryUsingPOST(deviceToken: string, json: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<DeferredResultResponseEntity>;
    // tslint:disable-next-line:max-line-length
    public postTelemetryUsingPOST(deviceToken: string, json: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpResponse<DeferredResultResponseEntity>>;
    // tslint:disable-next-line:max-line-length
    public postTelemetryUsingPOST(deviceToken: string, json: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpEvent<DeferredResultResponseEntity>>;
    // tslint:disable-next-line:max-line-length
    public postTelemetryUsingPOST(deviceToken: string, json: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*'}): Observable<any> {
        if (deviceToken === null || deviceToken === undefined) {
            throw new Error('Required parameter deviceToken was null or undefined when calling postTelemetryUsingPOST.');
        }
        if (json === null || json === undefined) {
            throw new Error('Required parameter json was null or undefined when calling postTelemetryUsingPOST.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (X-Authorization) required
        credential = this.configuration.lookupCredential('X-Authorization');
        if (credential) {
            headers = headers.set('X-Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                '*/*'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<DeferredResultResponseEntity>(`${this.configuration.basePath}/api/v1/${encodeURIComponent(String(deviceToken))}/telemetry`,
            json,
            {
                responseType: responseType as any,
                withCredentials: this.configuration.withCredentials,
                headers,
                observe,
                reportProgress
            }
        );
    }

    /**
     * replyToCommand
     * @param deviceToken deviceToken
     * @param requestId requestId
     * @param json json
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    // tslint:disable-next-line:max-line-length
    public replyToCommandUsingPOST(deviceToken: string, requestId: number, json: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<DeferredResultResponseEntity>;
    // tslint:disable-next-line:max-line-length
    public replyToCommandUsingPOST(deviceToken: string, requestId: number, json: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpResponse<DeferredResultResponseEntity>>;
    // tslint:disable-next-line:max-line-length
    public replyToCommandUsingPOST(deviceToken: string, requestId: number, json: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*'}): Observable<HttpEvent<DeferredResultResponseEntity>>;
    // tslint:disable-next-line:max-line-length
    public replyToCommandUsingPOST(deviceToken: string, requestId: number, json: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*'}): Observable<any> {
        if (deviceToken === null || deviceToken === undefined) {
            throw new Error('Required parameter deviceToken was null or undefined when calling replyToCommandUsingPOST.');
        }
        if (requestId === null || requestId === undefined) {
            throw new Error('Required parameter requestId was null or undefined when calling replyToCommandUsingPOST.');
        }
        if (json === null || json === undefined) {
            throw new Error('Required parameter json was null or undefined when calling replyToCommandUsingPOST.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (X-Authorization) required
        credential = this.configuration.lookupCredential('X-Authorization');
        if (credential) {
            headers = headers.set('X-Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                '*/*'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType: 'text' | 'json' = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.post<DeferredResultResponseEntity>(`${this.configuration.basePath}/api/v1/${encodeURIComponent(String(deviceToken))}/rpc/${encodeURIComponent(String(requestId))}`,
            json,
            {
                responseType: responseType as any,
                withCredentials: this.configuration.withCredentials,
                headers,
                observe,
                reportProgress
            }
        );
    }

    /**
     * subscribeToAttributes
     * @param deviceToken deviceToken
     * @param timeout timeout
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    // tslint:disable-next-line:max-line-length
    public subscribeToAttributesUsingGET(deviceToken: string, timeout?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<DeferredResultResponseEntity>;
    // tslint:disable-next-line:max-line-length
    public subscribeToAttributesUsingGET(deviceToken: string, timeout?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<DeferredResultResponseEntity>>;
    // tslint:disable-next-line:max-line-length
    public subscribeToAttributesUsingGET(deviceToken: string, timeout?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<DeferredResultResponseEntity>>;
    // tslint:disable-next-line:max-line-length
    public subscribeToAttributesUsingGET(deviceToken: string, timeout?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (deviceToken === null || deviceToken === undefined) {
            throw new Error('Required parameter deviceToken was null or undefined when calling subscribeToAttributesUsingGET.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (timeout !== undefined && timeout !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            timeout as any, 'timeout');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (X-Authorization) required
        credential = this.configuration.lookupCredential('X-Authorization');
        if (credential) {
            headers = headers.set('X-Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<DeferredResultResponseEntity>(`${this.configuration.basePath}/api/v1/${encodeURIComponent(String(deviceToken))}/attributes/updates${encodeURIComponent(String(timeout))}`,
            {
                params: queryParameters,
                responseType: responseType as any,
                withCredentials: this.configuration.withCredentials,
                headers,
                observe,
                reportProgress
            }
        );
    }

    /**
     * subscribeToCommands
     * @param deviceToken deviceToken
     * @param timeout timeout
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    // tslint:disable-next-line:max-line-length
    public subscribeToCommandsUsingGET(deviceToken: string, timeout?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<DeferredResultResponseEntity>;
    // tslint:disable-next-line:max-line-length
    public subscribeToCommandsUsingGET(deviceToken: string, timeout?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<DeferredResultResponseEntity>>;
    // tslint:disable-next-line:max-line-length
    public subscribeToCommandsUsingGET(deviceToken: string, timeout?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<DeferredResultResponseEntity>>;
    // tslint:disable-next-line:max-line-length
    public subscribeToCommandsUsingGET(deviceToken: string, timeout?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (deviceToken === null || deviceToken === undefined) {
            throw new Error('Required parameter deviceToken was null or undefined when calling subscribeToCommandsUsingGET.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (timeout !== undefined && timeout !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            timeout as any, 'timeout');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (X-Authorization) required
        credential = this.configuration.lookupCredential('X-Authorization');
        if (credential) {
            headers = headers.set('X-Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType: 'text' | 'json' = 'json';
        if (httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType = 'text';
        }

        return this.httpClient.get<DeferredResultResponseEntity>(`${this.configuration.basePath}/api/v1/${encodeURIComponent(String(deviceToken))}/rpc${encodeURIComponent(String(timeout))}`,
            {
                params: queryParameters,
                responseType: responseType as any,
                withCredentials: this.configuration.withCredentials,
                headers,
                observe,
                reportProgress
            }
        );
    }

}
